module.exports = __webpack_public_path__ + "img/71.5.COD.0ddf54f3.png";